import type { Location } from './Location';
import { LocationApi } from './LocationApi';
import { type Api, ApiFilterBuilder } from '@automapa/svelte-automapa-template';
import { _ } from 'svelte-i18n';
import { get } from 'svelte/store';

export class JobValidator {
    static checkExtIdIsNotEmpty(job: Location): boolean {
        if (!job.getExtId()) {
            return false;
        }
        if (job.getExtId() === '') {
            return false;
        }
        return true;
    }

    static async checkExtIdIsUnique(api: Api, job: Location): Promise<boolean> {
        let ext_id = job.getExtId();
        let f = new ApiFilterBuilder(1);
        let location = await LocationApi.getCountWithQueries(api, { ext_id_lower: ext_id?.toLocaleLowerCase(), $not: { id: job.id } }, f);
        return location.count === 0;
    }

    static async checkFullNameIsUnique(api: Api, job: Location): Promise<boolean> {
        let full_name = job.getFullName();
        let f = new ApiFilterBuilder(1);
        let location = await LocationApi.getCountWithQueries(api, { full_name: full_name, $not: { id: job.id } }, f);
        return location.count === 0;
    }

    static checkFullNameIsNotEmpty(job: Location): boolean {
        if (!job.getFullName()) {
            return false;
        }
        if (job.getFullName() === '') {
            return false;
        }
        return true;
    }

    static checkExtIdIsPartOfFullName(job: Location): boolean {
        let full_name = job.getFullName();
        let ext_id = job.getExtId();
        if (full_name && ext_id) {
            if (!full_name.includes(ext_id)) {
                return false;
            }
        }
        return true;
    }

    static checkLocationTypeIsNotEmpty(job: Location): boolean {
        let location_type = job.getLocationType();
        return !(location_type === null || location_type === '');
    }

    static checkCityNotEmpty(job: Location): boolean {
        if (!job.getData()?.address_attributes?.city) {
            return false;
        }
        return true;
    }

    static checkStreetNotEmpty(job: Location): boolean {
        if (!job.getData()?.address_attributes?.street) {
            return false;
        }
        return true;
    }

    static async checkUniqueExtId(api: Api, job: Location): Promise<string> {
        if (!JobValidator.checkExtIdIsNotEmpty(job)) {
            return `Ext id cannot be empty`;
        }

        let uniqueExtId = await JobValidator.checkExtIdIsUnique(api, job);
        console.log('uniqueExtId', uniqueExtId);
        if (!uniqueExtId) {
            return get(_)(`This ext id is already used`) + `: ${job.getData()?.ext_id}`;
        }
        return '';
    }

    static async checkUniqueFullName(api: Api, job: Location, ext_id_must_exists_in_full_name: boolean): Promise<string> {
        let checkIfUnique = false;
        if (!JobValidator.checkFullNameIsNotEmpty(job) && ext_id_must_exists_in_full_name) {
            return `Full name cannot be empty`;
        }
        if (ext_id_must_exists_in_full_name) {
            if (!JobValidator.checkExtIdIsPartOfFullName(job)) {
                return `Ext id must be part of full name`;
            }
        }
        if (checkIfUnique) {
            let uniqueFullName = await JobValidator.checkFullNameIsUnique(api, job);
            console.log('uniqueFullName', uniqueFullName);
            if (!uniqueFullName) {
                return get(_)('This full name is already used') + `: ${job.getData()?.full_name}`;
            }
        }
        return '';
    }
}
